import React, { useEffect, useState } from 'react';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'config/routes';
import { useDebounce } from 'hooks/useDebounce';
import { useProductSearch } from 'hooks/useProductSearch';

interface SmartSearchProps {
  fullWidth?: boolean;
  contrast?: boolean;
}

const SmartSearch: React.FC<SmartSearchProps> = ({ fullWidth = false, contrast = false }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const debounced = useDebounce(query, 400);
  const { results, loading } = useProductSearch(debounced, 5);

  useEffect(() => {
    if (debounced.trim().length >= 2 && results.length > 0) {
      // suggestions shown inline below
    }
  }, [debounced, results]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`${ROUTES.SEARCH}?q=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ flexGrow: 1, maxWidth: fullWidth ? 640 : 480, width: fullWidth ? '100%' : undefined }}
    >
      <TextField
        fullWidth
        size="small"
        placeholder={t('nav.search')}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        aria-label={t('nav.search')}
        sx={
          contrast
            ? {
                bgcolor: 'common.white',
                borderRadius: 1,
                '& .MuiOutlinedInput-root': {
                  bgcolor: 'common.white',
                },
              }
            : undefined
        }
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton type="submit" aria-label="buscar">
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {loading && debounced && (
        <Box sx={{ fontSize: 12, color: contrast ? 'rgba(255,255,255,0.8)' : 'text.secondary', mt: 0.5 }}>
          ...
        </Box>
      )}
    </Box>
  );
};

export default SmartSearch;
